import { MOCK_SCE_CODE } from "..";
import { SceStatus } from "../../../types";

export const mockSceStatus: SceStatus = {
  sce_code: MOCK_SCE_CODE,
  sce_name: "sce name",
  expected_function: "sce function",
  status: 0,
};
